<template>
        <b-table
            :empty-text="this.$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="timeOff"
            :fields="mentoraTimeOffFields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded">
            <template v-slot:cell(selected_sessions)="row">
                <div v-if="row.item.selected_sessions.length">
                    <div v-for="(session,i) in row.item.selected_sessions" :key="i" >
                        {{ session.name }}
                    </div>
                </div>
            </template>
        </b-table>

</template>
<script>
import qs from "qs";
import MentoraTimeOffRequestFormServices from "@/services/MentoraTimeOffRequestFormServices";

export default {
    name: "TimeOfRequest",
    props:{
        filter:{
            type:Object
        }
    },
    data(){
        return {
            timeOff: [],
            mentoraTimeOffFields: [
                {key: ('student_number'), label: this.toUpperCase('student_number')},
                {key: 'name', label: this.toUpperCase('name')},
                {key: 'surname', label: this.toUpperCase('surname')},
                {key: 'selected_sessions', label: this.toUpperCase('selected_sessions')},
                {key: 'status_name', label: this.toUpperCase('status')},
            ],
        }
    },
    created() {
      this.getData()
    },
    methods:{
        getData(){
            const timeOfConfig = {
                ...this.filter,
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            MentoraTimeOffRequestFormServices.getAll(timeOfConfig)
                .then(response => {
                    this.timeOff = response.data.data;
                }).catch(e => {
                this.showErrors(e);
            })

        }
    }
}
</script>

<style scoped>

</style>
